import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import vw from 'styles/utils';

function NewsCard(props) {
  const { imgUrl, title, author, url } = props;

  return (
    <Root href={url} target="_blank" rel="noreferrer">
      <Wrapper img={imgUrl}>
        <NewsLabel>New</NewsLabel>
        <LeftBottomWrapper>
          <Title>{title}</Title>
          <Author>{author}</Author>
        </LeftBottomWrapper>
      </Wrapper>
    </Root>
  )
}

NewsCard.propTypes = {
  imgUrl: PropTypes.any,
  title: PropTypes.string,
  author: PropTypes.string,
  url: PropTypes.string
}

const Root = styled.a`
  display: contents;

  &:hover {
    h5, h6 {
      color: #3398DC;
    }
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${props => `url(${props.img})`};
  background-size: cover;
  background-position: center;
  position: relative;
  transition: all 0.3s;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.55));
  }
`;

const NewsLabel = styled.span`
  position: absolute;
  background: #3398DC;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  color: #FFFFFF;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;

  ${vw('font-size', 8, 12)}
  ${vw('line-height', 14, 22)}
  ${vw('top', 8, 15)}
  ${vw('left', 8, 15)}
  ${vw('padding-left', 8, 15)}
  ${vw('padding-right', 8, 15)}
`;

const LeftBottomWrapper = styled.div`
  position: absolute;
  

  ${vw('left', 8, 15)}
  ${vw('bottom', 8, 15)}
  ${vw('margin-right', 8, 15)}
`;

const Title = styled.h5`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  color: #FFFFFF;
  transition: all 0.25s;

  ${vw('font-size', 12, 18)}
  ${vw('line-height', 20, 28)}
`;

const Author = styled.h6`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  color: #FFFFFF;
  transition: all 0.25s;

  ${vw('font-size', 10, 14)}
  ${vw('line-height', 18, 25)}
`;

export default NewsCard
